
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  watch,
  computed,
} from 'vue'
import { Toast } from 'vant'
import { getAllCityData, getNearCityByName } from '@/http/api'
import { useStore } from 'vuex'

interface CityItem {
  cityName: string
  cityId: number | string
  cityCode?: number | string
}

declare global {
  interface Window {
    LocateAuto: any
    Locate: any
  }
}

export default defineComponent({
  emits: ['select-city'],
  setup(props, { emit }) {
    const store = useStore()
    const letters = [
      '热门',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ]
    const hotData: CityItem[] = [
      { cityName: '广州', cityCode: 440100, cityId: 1 },
      { cityName: '北京', cityCode: 110000, cityId: 2 },
      { cityName: '上海', cityCode: 310000, cityId: 3 },
      { cityName: '深圳', cityCode: 440300, cityId: 4 },
      { cityName: '天津', cityCode: 120000, cityId: 257 },
      { cityName: '南京', cityCode: 320100, cityId: 177 },
      { cityName: '武汉', cityCode: 420100, cityId: 76 },
      { cityName: '沈阳', cityCode: 210100, cityId: 127 },
      { cityName: '西安', cityCode: 610100, cityId: 45 },
      { cityName: '郑州', cityCode: 410100, cityId: 267 },
      { cityName: '长沙', cityCode: 430100, cityId: 117 },
      { cityName: '重庆', cityCode: 500000, cityId: 77 },
    ]

    const data: any = reactive({
      nearbyCities: [],
      selectLetter: '热门',
      allCitiesData: [],
      showCities: hotData,
      currentCity: computed(() => store.state.locationInfo),
      isShowLoading: false,
      activityInfo: computed(() => store.state.activityInfo),
      browserEnv: computed(() => store.state.browserEnv),
    })

    const selectCity = (cityItem: CityItem) => {
      emit('select-city', {
        cityId: cityItem.cityId,
        city: cityItem.cityName,
        cityCode: cityItem.cityCode,
        msg: '', // 城市定位信息:浏览器定位成功/失败,传百度sdk失败状态码
        dataType: 'user',// 城市定位类型:0-其他，1-浏览器定位,2-ip定位,3-用户选择，4-定位失败
        version: '2.0.0'  // 城市定位版本:1-旧版本,2-新版本
      })
      setCityCookie(cityItem.cityId)
    }

    const selectNearByCity = (cityItem: any) => {
      emit('select-city', {
        cityId: cityItem.id,
        city: cityItem.name,
        cityCode: cityItem.code,
        msg: '', // 城市定位信息:浏览器定位成功/失败,传百度sdk失败状态码
        dataType: 'user',// 城市定位类型:0-其他，1-浏览器定位,2-ip定位,3-用户选择，4-定位失败
        version: '2.0.0'  // 城市定位版本:1-旧版本,2-新版本
      })
      setCityCookie(cityItem.id)
    }

    // 从旧有 https://js.3conline.com/wap/pcauto/2016/js/ku_search_city.js 搬过来的
    const setCityCookie = (cityId: number | string) => {
      if (!window.LocateAuto) return
      // 用户偏好设置
      window.LocateAuto.setByCityId(
        cityId,
        (data: any) => {
          // 成功请求接口后执行方法
          const cookie = {
            // 兼容旧版城市定位cookie(locationWap)
            pro: data.pro, // 定位的省份
            proCode: data.proCode, // 定位的省份ID
            city: data.city, // 定位的城市
            cityCode: data.cityCode, // 定位的城市ID
            regionPro: data.proId, // 经销商省份ID
            regionCity: data.cityId, // 经销商城市ID
            url: data.url, // 对应分站页面地址
            expires: data.expires, // 过期时间
          }
          window.Locate.setCookie(
            'locationWap',
            window.Locate.stringifyResult(cookie),
          )
          const AplocationWapCookie = {
            // 车型库的城市定位公用cookie(AplocationWap)
            regionId: data.cityId,
            regionName: data.city,
          }
          window.Locate.setCookie(
            'AplocationWap',
            window.Locate.stringifyResult(AplocationWapCookie),
          )
        },
        (error: Error) => {
          // 请求接口异常执行方法，返回的数据记录了错误信息
          // eslint-disable-next-line no-console
          console.log(error)
        },
      )
    }
    const OnSelectLetter = (letter: string, index: number) => {
      if (data.allCitiesData[index].length > 0) {
        data.selectLetter = letter
        data.showCities = data.allCitiesData[index]
      }
    }
    // 重新定位
    const reLocate = () => {
      data.isShowLoading = true
      window.LocateAuto.reLocate((res: any) => {
        if (!res || res.dataType === 'default') {
          Toast('定位失败！')
        } else {
          emit('select-city', {
            city: res.city.replace('市', ''),
            cityId: res.cityId,
            cityCode: res.cityCode,
            locationMessage: res.msg || '', // 城市定位信息:浏览器定位成功/失败,传百度sdk失败状态码
            dataType: res.dataType,// 城市定位类型:0-其他，1-浏览器定位,2-ip定位,3-用户选择，4-定位失败
            version: res.version  // 城市定位版本:1-旧版本,2-新版本
          })
        }
        data.isShowLoading = false
      })
    }

    const methods = {
      // 禁止在app里面触发touchMove事件
      webViewModel(status: any) {
        if (data.browserEnv === 1) { // app
            window.webViewModel &&
            window.webViewModel.webViewMoveVertical &&
            window.webViewModel.webViewMoveVertical(status)
        }
      },
      // 所有城市数
      async getCityData() {
        const res: any = await getAllCityData()
        if (res.code === 0 && res.data && res.data.list) {
          methods.setAllCitiesData(res.data.list)
        }
      },
      // 获取附近城市
      async getNearbyCities() {
        const res: any = await getNearCityByName(data.currentCity.city)
        if (res.code === 0) {
          if (res.data.list.length > 0) {
            data.nearbyCities = res.data.list
          }
        }
      },
      // 设置城市
      setAllCitiesData(citys: any[]) {
        const cityLen: number = citys.length
        const aData: any[] = []
        const bData: any[] = []
        const cData: any[] = []
        const dData: any[] = []
        const eData: any[] = []
        const fData: any[] = []
        const gData: any[] = []
        const hData: any[] = []
        const iData: any[] = []
        const jData: any[] = []
        const kData: any[] = []
        const lData: any[] = []
        const mData: any[] = []
        const nData: any[] = []
        const oData: any[] = []
        const pData: any[] = []
        const qData: any[] = []
        const rData: any[] = []
        const sData: any[] = []
        const tData: any[] = []
        const uData: any[] = []
        const vData: any[] = []
        const wData: any[] = []
        const xData: any[] = []
        const yData: any[] = []
        const zData: any[] = []
        for (let j = 0; j < cityLen; j++) {
          if (citys[j].cityLetter === 'A') {
            aData.push(citys[j])
          } else if (citys[j].cityLetter === 'B') {
            bData.push(citys[j])
          } else if (citys[j].cityLetter === 'C') {
            cData.push(citys[j])
          } else if (citys[j].cityLetter === 'D') {
            dData.push(citys[j])
          } else if (citys[j].cityLetter === 'E') {
            eData.push(citys[j])
          } else if (citys[j].cityLetter === 'F') {
            fData.push(citys[j])
          } else if (citys[j].cityLetter === 'G') {
            gData.push(citys[j])
          } else if (citys[j].cityLetter === 'H') {
            hData.push(citys[j])
          } else if (citys[j].cityLetter === 'I') {
            iData.push(citys[j])
          } else if (citys[j].cityLetter === 'J') {
            jData.push(citys[j])
          } else if (citys[j].cityLetter === 'K') {
            kData.push(citys[j])
          } else if (citys[j].cityLetter === 'L') {
            lData.push(citys[j])
          } else if (citys[j].cityLetter === 'M') {
            mData.push(citys[j])
          } else if (citys[j].cityLetter === 'N') {
            nData.push(citys[j])
          } else if (citys[j].cityLetter === 'O') {
            oData.push(citys[j])
          } else if (citys[j].cityLetter === 'P') {
            pData.push(citys[j])
          } else if (citys[j].cityLetter === 'Q') {
            qData.push(citys[j])
          } else if (citys[j].cityLetter === 'R') {
            rData.push(citys[j])
          } else if (citys[j].cityLetter === 'S') {
            sData.push(citys[j])
          } else if (citys[j].cityLetter === 'T') {
            tData.push(citys[j])
          } else if (citys[j].cityLetter === 'U') {
            uData.push(citys[j])
          } else if (citys[j].cityLetter === 'V') {
            vData.push(citys[j])
          } else if (citys[j].cityLetter === 'W') {
            wData.push(citys[j])
          } else if (citys[j].cityLetter === 'X') {
            xData.push(citys[j])
          } else if (citys[j].cityLetter === 'Y') {
            yData.push(citys[j])
          } else if (citys[j].cityLetter === 'Z') {
            zData.push(citys[j])
          }
        }
        data.allCitiesData = [
          hotData,
          aData,
          bData,
          cData,
          dData,
          eData,
          fData,
          gData,
          hData,
          iData,
          jData,
          kData,
          lData,
          mData,
          nData,
          oData,
          pData,
          qData,
          rData,
          sData,
          tData,
          uData,
          vData,
          wData,
          xData,
          yData,
          zData,
        ]
      },
    }

    onMounted(() => {
      methods.getNearbyCities()
      methods.getCityData()
    })

    watch([() => data.currentCity?.cityId], () => {
      methods.getNearbyCities()
    })

    return {
      ...toRefs(data),
      selectCity,
      selectNearByCity,
      OnSelectLetter,
      letters,
      reLocate,
      ...methods,
    }
  },
})
